/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_HE_IL: Record<string, string> = {
    ariaAnnounceChart: 'תרשים, ${seriesCount}[number] סדרות',
    ariaAnnounceFlowProportionLink: 'קישור ${index} מתוך ${count}, מ-${from} ל-${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'צומת ${index} מתוך ${count}, ${description}',
    ariaAnnounceGaugeChart: 'תרשים מד, ${caption}',
    ariaAnnounceHierarchyChart: 'תרשים היררכי, ${caption}',
    ariaAnnounceHierarchyDatum: 'רמה ${level}[number], ${count}[number] ילדים, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'לחץ על מקש הרווח או אנטר כדי להחליף את הנראות',
    ariaLabelAddHorizontalLine: 'הוסף קו אופקי',
    ariaLabelAnnotationOptionsToolbar: 'אפשרויות הערות',
    ariaLabelAnnotationSettingsDialog: '"הגדרות הערות"',
    ariaLabelColorPicker: 'בוחר צבעים',
    ariaLabelFinancialCharts: 'תרשימים פיננסיים',
    ariaLabelLegend: 'מקרא',
    ariaLabelLegendItem: '${label}, פריט באגדה ${index}[number] מתוך ${count}[number]',
    ariaLabelLegendItemUnknown: 'פריט מקרא לא ידוע',
    ariaLabelLegendPageNext: 'עמוד המקרא הבא',
    ariaLabelLegendPagePrevious: 'עמוד המקרא הקודם',
    ariaLabelLegendPagination: 'נווט בדפי המקרא',
    ariaLabelNavigator: 'נווט',
    ariaLabelNavigatorMaximum: 'מקסימום',
    ariaLabelNavigatorMinimum: 'מינימום',
    ariaLabelNavigatorRange: 'טווח',
    ariaLabelRangesToolbar: 'טווחים',
    ariaLabelSettingsTabBar: 'הגדרות',
    ariaLabelZoomToolbar: 'זום',
    ariaValuePanRange: '${min}[percent0to2dp] עד ${max}[percent0to2dp]',
    contextMenuDownload: 'הורדה',
    contextMenuPanToCursor: 'גלול לפה',
    contextMenuToggleOtherSeries: 'החלף נראות של סדרות אחרות',
    contextMenuToggleSeriesVisibility: 'החלף נראות',
    contextMenuZoomToCursor: 'התקרב לכאן',
    dialogHeaderChannel: 'ערוץ',
    dialogHeaderDatePriceRange: 'תאריך ומחיר',
    dialogHeaderDateRange: " 'טווח תאריכים'",
    dialogHeaderFibonacciRange: 'תיקון פיב',
    dialogHeaderLine: 'קו',
    dialogHeaderPriceRange: 'טווח מחירים',
    dialogHeaderText: 'טקסט',
    dialogInputAlign: 'ישור',
    dialogInputColorPicker: 'צבע',
    dialogInputColorPickerAltText: 'צבע טקסט',
    dialogInputExtendAbove: 'להרחיב למעלה',
    dialogInputExtendBelow: 'הרחב מטה',
    dialogInputExtendChannelEnd: 'הארך סוף ערוץ',
    dialogInputExtendChannelStart: 'הרחב תחילת ערוץ',
    dialogInputExtendLeft: 'הרחב שמאלה',
    dialogInputExtendLineEnd: 'הרחב קצה קו',
    dialogInputExtendLineStart: 'הרחב התחלת הקו',
    dialogInputExtendRight: 'שלח לימין',
    dialogInputFibonacciBands: 'רצועות',
    dialogInputFibonacciBandsAltText: "רצועות פיבונאצ'י",
    dialogInputFillColorPicker: 'מילוי',
    dialogInputFillColorPickerAltText: 'צבע מילוי',
    dialogInputFontSize: 'גודל',
    dialogInputFontSizeAltText: 'גודל גופן',
    dialogInputLineStyle: 'קו מקווקו',
    dialogInputPosition: 'מיקום',
    dialogInputReverse: 'הפוך',
    dialogInputShowFill: 'הצג מילוי',
    dialogInputStrokeWidth: 'משקל',
    dialogInputStrokeWidthAltText: 'משקל הקו',
    iconAltTextAlignCenter: 'מרכז',
    iconAltTextAlignLeft: 'שמאל',
    iconAltTextAlignRight: 'מיושר ימינה',
    iconAltTextClose: 'סגור',
    iconAltTextLineStyleDashed: 'ארוך מקווקו',
    iconAltTextLineStyleDotted: 'מְקוּוָו קָצָר',
    iconAltTextLineStyleSolid: 'מוצק',
    iconAltTextPositionBottom: 'תחתון',
    iconAltTextPositionCenter: 'מרכז',
    iconAltTextPositionTop: 'למעלה',
    inputTextareaPlaceholder: 'הוסף טקסט',
    measurerDateRangeBars: '${value}[number] קווים',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'נפח ${value}',
    overlayLoadingData: 'טוען נתונים...',
    overlayNoData: 'אין נתונים להצגה',
    overlayNoVisibleSeries: 'אין סדרות להציג',
    overlayUnsupportedBrowser: 'גרסת דפדפן לא תואמת. נא לשדרג את הדפדפן שלך.',
    seriesHistogramTooltipCount: '${yName} (כמות)',
    seriesHistogramTooltipFrequency: 'תדירות',
    seriesHistogramTooltipMean: '${yName} (ממוצע)',
    seriesHistogramTooltipSum: '${yName} (סכום)',
    toolbarAnnotationsArrow: 'חץ',
    toolbarAnnotationsArrowDown: 'חץ למטה',
    toolbarAnnotationsArrowUp: 'חץ למעלה',
    toolbarAnnotationsCallout: 'הערה',
    toolbarAnnotationsClearAll: 'נקה הכל',
    toolbarAnnotationsComment: 'תגובה',
    toolbarAnnotationsDatePriceRange: 'תאריך ומחיר',
    toolbarAnnotationsDateRange: 'טווח תאריכים',
    toolbarAnnotationsDelete: 'מחק',
    toolbarAnnotationsDisjointChannel: 'ערוץ מנותק',
    toolbarAnnotationsDragHandle: 'גרור סרגל כלים',
    toolbarAnnotationsFibonacciAnnotations: "פיבונאצ'י",
    toolbarAnnotationsFibonacciRetracement: "תיקון פיבונאצ'י",
    toolbarAnnotationsFibonacciRetracementTrendBased: 'פיב טרנד מבוסס',
    toolbarAnnotationsFillColor: 'צבע מילוי',
    toolbarAnnotationsHorizontalLine: 'קו אופקי',
    toolbarAnnotationsLineAnnotations: 'קווי מגמה',
    toolbarAnnotationsLineColor: 'צבע הקו',
    toolbarAnnotationsLineStrokeWidth: 'עובי קו',
    toolbarAnnotationsLineStyle: 'סגנון קו',
    toolbarAnnotationsLock: 'נעל',
    toolbarAnnotationsMeasurerAnnotations: 'מודד',
    toolbarAnnotationsNote: 'הערה',
    toolbarAnnotationsParallelChannel: 'ערוץ מקבילי',
    toolbarAnnotationsPriceRange: 'טווח מחירים',
    toolbarAnnotationsQuickDatePriceRange: 'הערכה',
    toolbarAnnotationsSettings: 'הגדרות',
    toolbarAnnotationsShapeAnnotations: 'חיצים',
    toolbarAnnotationsText: 'טקסט',
    toolbarAnnotationsTextAnnotations: 'הערות טקסט',
    toolbarAnnotationsTextColor: 'צבע טקסט',
    toolbarAnnotationsTextSize: 'גודל טקסט',
    toolbarAnnotationsTrendLine: 'קו מגמה',
    toolbarAnnotationsUnlock: 'שחרר',
    toolbarAnnotationsVerticalLine: 'קו אנכי',
    toolbarRange1Month: '1 חודש',
    toolbarRange1MonthAria: 'חודש אחד',
    toolbarRange1Year: 'שנה 1',
    toolbarRange1YearAria: 'שנה אחת',
    toolbarRange3Months: '3 חודשים',
    toolbarRange3MonthsAria: '3 חודשים',
    toolbarRange6Months: '6ח',
    toolbarRange6MonthsAria: '6 חודשים',
    toolbarRangeAll: 'הכל',
    toolbarRangeAllAria: 'הכל',
    toolbarRangeYearToDate: 'השנה',
    toolbarRangeYearToDateAria: 'השנה',
    toolbarSeriesTypeCandles: 'נרות',
    toolbarSeriesTypeDropdown: 'סוג תרשים',
    toolbarSeriesTypeHighLow: 'גבוה נמוך',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'נרות חלולים',
    toolbarSeriesTypeLine: 'קו',
    toolbarSeriesTypeLineWithMarkers: 'קו עם סימונים',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'קו מדרגות',
    toolbarZoomPanEnd: 'גלול לסוף',
    toolbarZoomPanLeft: 'גלול שמאלה',
    toolbarZoomPanRight: 'גלול ימינה',
    toolbarZoomPanStart: 'גלול להתחלה',
    toolbarZoomReset: 'אפס זום',
    toolbarZoomZoomIn: 'התקרב',
    toolbarZoomZoomOut: 'התרחק',
    tooltipPaginationStatus: '${index}[number] מתוך ${count}[number]',
};
